import he from 'he';


export const getHTMLRemovedQuestion = (HTMLQuestion) => {
    return (he.decode(HTMLQuestion.replace(/<[^>]*>?/gm, '')));
}